import localFun from '@/utils/local-ope';

const state = {
  sidebar: {
    opened: localFun.get('sidebarStatus')
      ? !!+localFun.get('sidebarStatus')
      : true,
    withoutAnimation: false
  },
  device: 'desktop',
  goBackRouter: 1,
  customerGoBackRouter: 1,
  permissionCodes: [],
  userData: {},
  sensitiveWords: [],
  menusAlisa: [],
  tableFilter: {},
  speakerAllInfo: false,
  isNewVersion: false,
  materialAllPermission: false.valueOf(),
  contractDetail: {},
  accountProviderProvinceSwitch: false,
  masterDataOnRegion: false,
  orderManagentTab:undefined,
  // 是否为服务商账号
  isProviderAccount: false,
};

const mutations = {
  SET_IS_PROVIDER_ACCOUNT: (data, payload) => {
    data.isProviderAccount = payload;
  },
  SET_ISNREVERSION: (data, payload) => {
    data.isNewVersion = payload;
  },
  SET_TABLE_FILTER: (data, payload) => {
    const key = payload.key;
    data.tableFilter[key] = payload.filters;
  },
  GO_BACK_ROUTER: (data, payload) => {
    data.goBackRouter = payload;
  },
  CUSTOMER_GO_BACK_ROUTER: (stateCustomerGoBackRouter, payload) => {
    stateCustomerGoBackRouter.customerGoBackRouter = payload;
  },
  TOGGLE_SIDEBAR: (data) => {
    data.sidebar.opened = !data.sidebar.opened;
    data.sidebar.withoutAnimation = false;
    if (data.sidebar.opened) {
      localFun.set('sidebarStatus', 1);
    } else {
      localFun.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: (dataSideBar, withoutAnimation) => {
    localFun.set('sidebarStatus', 0);
    dataSideBar.sidebar.opened = false;
    dataSideBar.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (dataSideBar, device) => {
    dataSideBar.device = device;
  },
  SET_PERMISSION_CODES: (data, payload) => {
    data.permissionCodes = payload;
  },
  SET_CONFIG_SOURCE: (data, payload) => {
    data.configSource = payload;
  },
  SET_SPEAKERALLINFO: (data, payload) => {
    data.speakerAllInfo = payload;
  },
  SET_USER_DATA: (data, payload) => {
    data.userData = payload;
  },
  SET_SENSITIVE_WORDS: (data, payload) => {
    data.sensitiveWords = payload;
  },
  SET_MENUS_ALISA: (data, payload) => {
    data.menusAlisa = payload;
  },
  SET_MATERIAL_ALL_PERMISSION: (data, payload) => {
    data.materialAllPermission = payload;
  },
  CLEAR_PERMISSION_CODES: (data) => {
    data.permissionCodes = [];
  },
  CLEAR_USER_DATA: (data) => {
    data.userData = {};
  },
  CLEAR_MENUS_ALISA: (data) => {
    data.menusAlisa = [];
  },
  CLEAR_TABLE_FILTER: (data) => {
    data.tableFilter = {};
  },
  CLEAR_MATERIAL_ALL_PERMISSION: (data) => {
    data.materialAllPermission = false;
  },
  setContractDetail: (state, payload) => {
    // 设置合同详情
    state.contractDetail = payload;
  },
  SET_ACCOUNT_PROVIDER_PROVINCE_SWITCH: (data, payload) => {
    data.accountProviderProvinceSwitch = payload;
  },
  SET_MASTER_DATA_ON_REGION: (data, payload) => {
    data.masterDataOnRegion = payload;
  },
  SET_ORDER_MANAGEMENT_TAB: (data, payload) => {
    data.orderManagentTab = payload;
  },
};

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
